import React from "preact/compat";
import { h, Component } from 'preact';
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import TextGraphicAnimations from "./TextGraphicAnimations";

export default @connect(reduce, actions)
class AsideAnimations extends Component {
  constructor() {
    super()
  }

  render(props, state) {
    return (<div id="app-aside-wordart" class="app-aside-animations">
      <TextGraphicAnimations/>
    </div>)
  }
}
